import { decodePayload } from './decode-payload';

const ACCESS_TOKEN_NAME = 'accessToken';
const REFRESH_TOKEN_NAME = 'refreshToken';
const AUTH_COOKIE_DOMAIN =
    (window as any).AUTH_COOKIE_DOMAIN ?? process.env.REACT_APP_AUTH_COOKIE_DOMAIN;
const KEYCLOAK_CLIENT_ID =
    (window as any).KEYCLOAK_CLIENT_ID ?? process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? 'buszrent-busman';

const KEYCLOAK_ENDPOINT =
    (window as any).KEYCLOAK_API_ENDPOINT ?? process.env.REACT_APP_KEYCLOAK_API_ENDPOINT;
const KEYCLOAK_LOGOUT_ENDPOINT: string | undefined = KEYCLOAK_ENDPOINT?.replace('/token', '/logout');
const KEYCLOAK_USERINFO_ENDPOINT: string | undefined = KEYCLOAK_ENDPOINT?.replace('/token', '/userinfo');

export const getCookieByName = (name: string): string | undefined => {
    const cookies = document.cookie.split('; ');
    return cookies?.find(cookie => cookie.startsWith(`${name}=`))?.replace(`${name}=`, '') ?? undefined;
};

export const setCookieByName = (name: string, value: string) => {
    const { exp } = decodePayload(value);
    document.cookie = name + '=' + value + '; domain=' + AUTH_COOKIE_DOMAIN + '; path=/; expires=' + new Date(exp * 1000).toUTCString();
};

export const removeCookieByName = (name: string) => {
    document.cookie = name + '=' + '; domain=' + AUTH_COOKIE_DOMAIN + '; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

export const getAuthToken = () => getCookieByName(ACCESS_TOKEN_NAME);
export const getRefreshToken = () => getCookieByName(REFRESH_TOKEN_NAME);

export const invalidateKeycloakSession = () => {
    const refreshToken = getRefreshToken();
    if (KEYCLOAK_LOGOUT_ENDPOINT && refreshToken && KEYCLOAK_CLIENT_ID) {
        fetch(KEYCLOAK_LOGOUT_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                client_id: KEYCLOAK_CLIENT_ID,
                refresh_token: refreshToken,
            }),
        }).catch(() => {});
    }
};

export const validateSession = async (accessToken?: string): Promise<boolean> => {
    const token = accessToken ?? getAuthToken();
    if (!token || !KEYCLOAK_USERINFO_ENDPOINT) {
        return false;
    }

    try {
        const response = await fetch(KEYCLOAK_USERINFO_ENDPOINT, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.ok;
    } catch {
        return false;
    }
};

export const removeAllAuthCookies = () => {
    removeCookieByName(ACCESS_TOKEN_NAME);
    removeCookieByName(REFRESH_TOKEN_NAME);
};

export { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME, KEYCLOAK_CLIENT_ID, KEYCLOAK_ENDPOINT, KEYCLOAK_USERINFO_ENDPOINT };
